Drupal.behaviors.analyticsTablePlaceholders = {
  attach: function (context, settings) {
    const root = context || document;

    function typeText(element, text, interval = 70) {
      let i = 0;
      element.textContent = "";
      element.dataset.typing = "1";
      const id = setInterval(() => {
        if (!element.dataset.typing) {
          clearInterval(id);
          return;
        }
        element.textContent = text.slice(0, i + 1);
        i++;
        if (i === text.length) {
          clearInterval(id);
        }
      }, interval);
      element._typeInterval = id;
    }

    function stopTyping(element) {
      if (element && element._typeInterval) {
        clearInterval(element._typeInterval);
        delete element.dataset.typing;
        delete element._typeInterval;
      }
    }

    // Typing animation on analysis text, only once per element.
    const statusText = root.querySelector(".olex-analysis-text h6");
    if (statusText && !statusText.dataset.typingStarted) {
      statusText.dataset.typingStarted = "1";
      typeText(statusText, "Olex is analysing your data");
    }

    // avoid repeated initialization.
    const placeholders = once(
      "analyticsPlaceholders",
      root.querySelectorAll("body")
    );
    if (placeholders.length === 0) return;

    const mapping = [
      {
        skeleton: [".mat-placeholder-table--school"],
        table: ".school-switcher",
        loaded: false,
      },
      {
        skeleton: [
          ".mat-placeholder-table--data",
          ".mat-placeholder-table--gap",
        ],
        table: ".insight-blocks-container",
        loaded: false,
      },
    ];

    let observer;

    function getSkeletonElements(selectors) {
      return selectors.map((sel) => root.querySelector(sel)).filter(Boolean);
    }

    function allLoaded() {
      // Get the items that exist in the DOM
      const existingItems = mapping.filter((item) => {
        const el = root.querySelector(item.table);
        if (!el) {
          // Element not found
          return false;
        }
        return true;
      });
      // check if all the existing items are loaded
      return existingItems.every((item) => item.loaded === true);
    }

    function waitForTableReady(item) {
      if (item.loaded || item._intervalStarted) return;

      const table = root.querySelector(item.table);
      const skeletonEls = getSkeletonElements(item.skeleton);
      if (!table || skeletonEls.length === 0) return;

      item._intervalStarted = true;

      let attempts = 0;
      const maxAttempts = 100;
      const interval = setInterval(() => {
        if (++attempts >= maxAttempts) {
          clearInterval(interval);
          console.warn(`Timeout waiting for ${item.table} readiness`);
          item._intervalStarted = false;
          return;
        }

        const rows = table.querySelectorAll("tr");
        const select = table.querySelector("select");

        if (rows.length > 0 || select !== null) {
          clearInterval(interval);
          skeletonEls.forEach((el) => (el.style.display = "none"));
          table.style.display = "";
          table.classList.add("visible");
          item.loaded = true;

          if (allLoaded()) {
            const insight = root.querySelector(".insight-blocks-container");
            if (insight) {
              insight.classList.add("visible");
            }

            if (statusText) {
              stopTyping(statusText);
              statusText.style.opacity = 0;
              setTimeout(() => {
                statusText.textContent = "Your data is ready";
                statusText.style.opacity = 1;
              }, 400);
            }

            if (observer) {
              observer.disconnect();
            }
          }
        }
      }, 100);
    }

    // Run the check immediately on attach, then observe DOM for changes.
    mapping.forEach(waitForTableReady);

    if (observer) {
      observer.disconnect();
    }

    observer = new MutationObserver(() => {
      mapping.forEach(waitForTableReady);
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
    });

    // disconnect observer after a timeout
    setTimeout(() => {
      if (observer) {
        observer.disconnect();
      }
    }, 30000);
  },
};
